import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image, Link } from '@react-pdf/renderer';

interface BasePDFDocumentProps {
    brandLogoBase64?: string;
    children: React.ReactNode;
    orientation?: 'portrait' | 'landscape';
    style?: any;
}

const styles = StyleSheet.create({
    page: {
        paddingTop: 40,
        paddingBottom: 60,
        paddingLeft: 30,
        paddingRight: 30,
        backgroundColor: '#ffffff',
        fontFamily: 'Helvetica'
    },
    brandingHeader: {
        position: 'absolute',
        top: 20,
        right: 30,
        flexDirection: 'row',
        alignItems: 'center'
    },
    brandingHeaderLogo: {
        width: 14,
        height: 14,
        marginRight: 6
    },
    brandingHeaderText: {
        fontSize: 10,
        color: '#94a3b8',
        fontWeight: 'bold',
        letterSpacing: 1
    },
    brandingFooter: {
        position: 'absolute',
        bottom: 16,
        left: 30,
        right: 30,
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderTopWidth: 0.5,
        borderTopColor: '#e2e8f0',
        borderTopStyle: 'solid',
        paddingTop: 6,
    },
    brandingFooterText: {
        fontSize: 8,
        color: '#64748b',
        letterSpacing: 1
    }
});

export const BasePDFDocument: React.FC<BasePDFDocumentProps> = ({
    brandLogoBase64,
    children,
    orientation = 'portrait',
    style
}) => {
    return (
        <Document>
            <Page size="A4" orientation={orientation} style={style || styles.page} wrap>
                {/* Global Branding Header */}
                <View style={styles.brandingHeader} fixed>
                    {brandLogoBase64 && <Image src={brandLogoBase64} style={styles.brandingHeaderLogo} />}
                    <Text style={styles.brandingHeaderText}>Storyverse</Text>
                </View>

                {/* Main Content Rendered Here */}
                {children}

                {/* Global Branding Footer with Pagination */}
                <View style={styles.brandingFooter} fixed>
                    <Text style={styles.brandingFooterText}>
                        <Link src="https://storyverse.aioncw.com" style={{ textDecoration: 'none', color: '#64748b' }}>
                            Create your Storyverse - storyverse.aioncw.com
                        </Link>
                    </Text>
                    <Text
                        style={styles.brandingFooterText}
                        render={({ pageNumber, totalPages }) => `PAGE ${pageNumber} OF ${totalPages}`}
                    />
                </View>
            </Page>
        </Document>
    );
};
